import { createActions } from 'redux-actions';
import { identity } from 'ramda';

const actionsDefinition = {
  SET_LICENSING_FILTER: identity,
  CLEAR_FILTERS: undefined,
};

export const { setLicensingFilter, clearFilters } = createActions(actionsDefinition);
